var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useState } from "react";
import { ButtonPanel } from "../../buttons";
export var EditGrid = function (props) {
    var _a = useState(''), search = _a[0], setSearch = _a[1];
    var _b = useState(props.items), itemsToShow = _b[0], setItemsToShow = _b[1];
    var doSearch = function () {
        setItemsToShow(props.items.map(function (item) {
            return __assign(__assign({}, item), { items: item.items.filter(function (item) {
                    return item.name.toLowerCase().includes(search.toLowerCase());
                }) });
        }));
    };
    useEffect(function () {
        doSearch();
    }, [search, props.items]);
    return (React.createElement("div", { className: 'EditGrid' },
        props.allowSearch && React.createElement("input", { className: "search-bar", name: "input", type: "text", value: search, onChange: function (e) { return setSearch(e.target.value); }, placeholder: "Search" }),
        React.createElement(ButtonPanel, { style: { width: '100%' }, header: 'Clear', items: [{ id: null, name: 'Clear' }], onClick: function (item) {
                props.onItemClicked(item.id);
            } }),
        itemsToShow.map(function (item) {
            return React.createElement(ButtonPanel, { key: item.name, header: item.name, items: item.items, onClick: function (item) {
                    props.onItemClicked(item.id);
                } });
        })));
};
//# sourceMappingURL=Grid.js.map